<template>
	<div class="hangcai">
		<!-- 搜索条件 -->
		<div class="search_win" style="margin-top:20px;text-align:center;">
			<quill-editor ref="text" v-model="content" class="myQuillEditor" :options="editorOption" />
			<el-button type="primary" @click="submit">提交</el-button>
		</div>
	</div>
</template>
<script>
	import { quillEditor } from 'vue-quill-editor'
	export default {
		data() {
			return {
				content: '',
				editorOption: {},
			}
		},
		components: {
		    quillEditor
		},
		methods: {
			// 富文本编译器提交
			submit () {
			    console.log(this.$refs.text.value)
			},
		}
	};
</script>
<style lang="scss" scoped>
	.search_win {
		width: 80%;
		height: auto;
		margin: 0 auto;
		padding: 20px;
		background-color: #FFFFFF;
		border-radius: 10px;
		margin-top: 20px;
	}
	.myQuillEditor{
		height:400px;
		margin-top: 50px;
		margin-bottom:50px;
	}
</style>
